/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_Closing_TitleInputs */

const en_portal_features_closing_title = /** @type {(inputs: Portal_Features_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with someone who knows what they are doing`)
};

const pl_portal_features_closing_title = /** @type {(inputs: Portal_Features_Closing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij z kimś, kto wie, co robi`)
};

/**
* | output |
* | --- |
* | "Start with someone who knows what they are doing" |
*
* @param {Portal_Features_Closing_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_closing_title = /** @type {((inputs?: Portal_Features_Closing_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_Closing_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_closing_title(inputs)
	return en_portal_features_closing_title(inputs)
});